// Tiny external store so the global FloatingLanguageToggle can tell whether an
// AppShell is currently mounted (admin chrome already shows its own toggle in the
// header). Avoids rendering two language switchers on the same page (ENG-111).
let mounted = false
const listeners = new Set<() => void>()

export const appShellPresence = {
  subscribe(cb: () => void) {
    listeners.add(cb)
    return () => { listeners.delete(cb) }
  },
  getSnapshot() {
    return mounted
  },
  set(value: boolean) {
    if (mounted === value) return
    mounted = value
    listeners.forEach((l) => l())
  },
}
